import { employee, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { nowISO } from "../utils/date-helpers";
import { patchRowVerified, type VerifiedWriteOptions } from "../powersync/verified-write";
import { generateId } from "@fleet/utils";

export type EmployeeRole = "waiter" | "cashier" | "manager";

/**
 * Creates an employee with PIN for quick login on shared POS. The PIN is a
 * short shift code (not an account credential); real authentication is
 * the logged-in user. CC-7: write with await.
 */
export async function createEmployeeMutation(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  name: string,
  opts?: { pin?: string; role?: EmployeeRole; branchId?: string | null },
): Promise<string> {
  const id = generateId();
  const now = nowISO();
  await db.insert(employee).values({
    id,
    organization_id: organizationId,
    branch_id: opts?.branchId ?? null,
    name: name.trim(),
    pin: opts?.pin?.trim() || null,
    role: opts?.role ?? "waiter",
    is_active: 1,
    created_at: now,
    updated_at: now,
  });
  return id;
}

export async function deleteEmployeeMutation(
  db: PowerSyncDrizzleDB,
  employeeId: string,
  options?: VerifiedWriteOptions,
): Promise<void> {
  await patchRowVerified(db, employee, employee.id, employeeId, { deleted_at: nowISO() }, options);
}

/** Verifies a PIN against loaded active employees; returns id or null.*/
export function findEmployeeByPin(
  employees: { id: string; pin: string | null }[],
  pin: string,
): string | null {
  const trimmed = pin.trim();
  if (!trimmed) {
    return null;
  }
  return employees.find((e) => e.pin === trimmed)?.id ?? null;
}
